import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarm,
  CPSConfigAlarmElement,
  CPSConfigCard,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';

export function P00030Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('taSAlarme') === 1) {
    if (getValue('taSEtatPile') !== 0) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.TAIR,
        functionalityTitle: 'P00030.dashboard.card.title',
        title: 'P00030.status.battery',
      });
    }

    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.TAIR,
        functionalityTitle: 'P00030.dashboard.card.title',
        title: 'P00030.status.productPresence',
      });
    }
  }

  return res;
}
